import { client } from '../api/client'
import { postresponse } from '../types/clockTypes'

const postclockin = (data: any): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`/OnBoarding/ClockPunchCreate`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not get data' })
      }
      return null
    } catch (error) {
      reject(error)
    }
  })
}

const updateclockin = (data: any): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.patch(`/OnBoarding/UpdateClockPunch`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not get data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const fetchattendancelogkey = (
  obkey: number,
  shiftid: number,
  employeeid: number,
  userid: number
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `/OnBoarding/GetAttendanceLog?essUserObkey=${obkey}&shiftId=${shiftid}&EmployeeId=${employeeid}&UserId=${userid}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not get data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const fetchClockinStatus = (
  obkey: number,
  shiftid: number,
  employeeid: number,
  userid: number,
  date: string
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `/OnBoarding/GetUserClockinStatus?essUserObkey=${obkey}&shiftId=${shiftid}&EmployeeId=${employeeid}&UserId=${userid}&date=${date}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not get data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const fetchdepartments = (
  Id: number,
  storeId: number,
  userid: number
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `/Employee/getdepartment?entityId=${Id}&storeId=${storeId}&userId=${userid}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not get data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

export const clockService = {
  postclockin,
  fetchdepartments,
  updateclockin,
  fetchattendancelogkey,
  fetchClockinStatus
}
